export const projectSuggestions = [
  'Show me key points from the whitepaper',
  "Show me data that dictates the project's tokenomics",
  "Show me the project's history",
  'Show me all key investors',
  'Show me everything',
];

export const bionicPlatformSuggestions = [
  'Show me the latest news',
  'Show me the latest projects',
  'Show me the latest updates',
  'Show me the latest partnerships',
  'Show me everything',
];
